import { INavItem } from './Models/INavItem';
import NavItem from './NavItem';
import { TvIcon } from '../icons/TvIcon';
import { HomeIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { ListBulletIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../../hooks/useAuth.tsx';

const Nav = () => {
    const NavItems: INavItem[] = [
        {
            title: '',
            icon: (
                <img
                    className={'mt-2 px-2 h-12'}
                    src={'/images/logo.png'}
                    alt="Beskid Media logo"
                />
            ),
            href: '/',
        },
        { title: 'Główna', icon: <HomeIcon className="w-8 h-8" />, href: '/' },
        { title: 'TV', icon: <TvIcon className="w-8 h-8" />, href: '/kanaly-tv' },
        {
            title: 'Program',
            icon: <ListBulletIcon className="w-8 h-8" />,
            href: '/program-tv',
        },
        {
            title: 'Szukaj',
            icon: <MagnifyingGlassIcon className="w-8 h-8" />,
            href: '/szukaj',
        },
    ];

    const _authService = useAuth();

    return (
        <div className="fixed h-full w-24 bg-neutral-950 space-y-1 z-20 border-r border-neutral-900">
            <ul className="h-full flex flex-col items-center justify-between pb-3">
                <span className={'space-y-1'}>
                    {NavItems.map((item) => (
                        <li key={item.title}>
                            <NavItem title={item.title} icon={item.icon} href={item.href} />
                        </li>
                    ))}
                </span>
                <li className={'w-full text-neutral-300 hover:text-gray-400 transition-color duration-200'}>
                    <NavItem title={'Profil'} icon={<UserCircleIcon className="w-8 h-8" />}
                             href={`${_authService.token ? '/ustawienia' : '/logowanie'}`} />
                </li>
            </ul>
        </div>
    );
};

export default Nav;
